import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { NavigationEnd, NavigationCancel, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AnalyticalToolsService } from './services/analytical-tools.service';
import { VersionCheckService } from './services/VersionCheckService';
import { MessagingService } from 'src/backend/services/messaging.service';
import { ConfigService } from './services/config.service';
import { DeploymentDetectorService } from './services/deployment-detector.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Obeikan Client';
  isLoading = false;
  showContent = false;
  rcaUrl = [
    '/at',
    '/at/sixwtwoh',
    '/at/fishbone',
    '/at/causeEffect',
    '/at/fivewhy',
    '/at/fivewhy-actpln',
  ];
  public languageDir = 'ltr';
  constructor(
    private router: Router,
    private translate: TranslateService,
    private analyticalToolsService: AnalyticalToolsService,
    private versionCheck: VersionCheckService,
    private messagingService: MessagingService,
    private configService: ConfigService,
    private deploymentDetector: DeploymentDetectorService
  ) {
    // Initialize Constants with runtime ConfigService
    Constants.initializeConfig(this.configService);
    console.log('✅ Runtime configuration initialized in Constants');
    
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang === 'ar') {
        this.languageDir = 'ltr';
      }
      else {
        this.languageDir = 'ltr';
      }
    });

    // firebase notification initialization
    this.messagingService.receiveMessage();
    // signal R initialization
    this.messagingService.InitializeSignalR();
    ;
    this.messagingService.recieveNotificationMessageFromSignalR();
  }

  ngOnInit(): void {
    //clear cache 
    this.router.events.subscribe((event) => {
      const url = document.location.href;
      const checkurl = document.location.origin + '/NewSfdcHoney';
      const checkurl1 = document.location.origin + '/NewSfdc';
      const checkurl2 = document.location.origin + '/handsfree-operator';
      if (url === checkurl || url === checkurl1 || url === checkurl2) {
        document.body.className = 'body_hide';
        document.body.style.paddingBottom = '0px';

      } else {
        document.body.className = 'body_change';
        document.body.style.paddingBottom = '90px';

      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.showContent = true;
        if (event.url !== '/' && !this.rcaUrl.includes(event.url)) {
          this.analyticalToolsService.setRca(false);
          this.analyticalToolsService.setRcaId(0);
          this.analyticalToolsService.setHeaderId(0);
          this.analyticalToolsService.setFilteredIndex(0);
          this.analyticalToolsService.setFilteredData([]);
          this.analyticalToolsService.setTeamLeaderList([]);
        }
      }

    });
    this.versionCheck.initVersionCheck(Constants.VERSION);
    this.deploymentDetector.initializeUpdateCheck();

  }


}
